import { allPass, anyPass, propEq, complement } from 'ramda';
import {
    MAX_DATE,
    registrationStatuses,
    statuses,
    RACE_RULE_STATUSES,
    COUNT_DOWN_TYPES
} from './constants';
import { LEADER_BOARD_RACES_LIST } from './RacesList/constants';
import { LEADER_BOARD_SLIDER } from './Slider/constants';

export const isRegInProgress = propEq('registrationStatus', registrationStatuses.IN_PROGRESS);
export const isRegNotStarted = propEq('registrationStatus', registrationStatuses.NOT_STARTED);
export const isRegNotFinished = complement(propEq('registrationStatus', registrationStatuses.FINISHED));
export const isPlayerJoined = propEq('joined', true);
export const isRaceActive = propEq('status', statuses.ACTIVE);
export const isRaceNotStarted = propEq('status', statuses.NOT_STARTED);
export const isRaceCompleted = propEq('status', statuses.COMPLETED);
export const isRacePending = propEq('status', statuses.PENDING_REVIEW);

export const isRaceAvailable = allPass([
    anyPass([isRaceActive, isRaceNotStarted]),
    isRegNotFinished
]);

export const isPendingRaceAvailable = allPass([isRacePending, isPlayerJoined]);

export const isJoinButtonAvailable = anyPass([isPlayerJoined, isRegInProgress, isRegNotStarted]);

export const startingFirst = (race, nextRace) =>
    new Date(race.leaderboardStartTime) - new Date(nextRace.leaderboardStartTime);

export const endingFirst = (race, nextRace) =>
    new Date(race.leaderboardEndTime) - new Date(nextRace.leaderboardEndTime);

export const recentlyEndedFirst = (race, nextRace) =>
    new Date(nextRace.leaderboardEndTime) - new Date(race.leaderboardEndTime);

export const onAirFirst = (race, nextRace) =>
    (nextRace.status === statuses.ACTIVE) - (race.status === statuses.ACTIVE);

export const upcomingFirst = (race, nextRace) =>
    (nextRace.status === statuses.NOT_STARTED) - (race.status === statuses.NOT_STARTED);

export const joinedFirst = (race, nextRace) =>
    nextRace.joined - race.joined;

export const checkEndDate = (endDate) => endDate ? new Date(endDate) : new Date(MAX_DATE);

export const endRegistrationFirst = (race, nextRace) =>
    checkEndDate(race.registrationEndTime) - checkEndDate(nextRace.registrationEndTime);

export const isLeaderBoardEligible = portletType => (leaderBoard) => {
    if (portletType === LEADER_BOARD_SLIDER) {
        return isRaceAvailable(leaderBoard);
    } else if (portletType === LEADER_BOARD_RACES_LIST) {
        return anyPass([isRaceCompleted, isRaceAvailable, isPendingRaceAvailable])(leaderBoard);
    }

    return false;
};

export const isCompletedRule = propEq('status', RACE_RULE_STATUSES.completed);

export const byRuleStatus = (rule, nextRule) =>
    (rule.status === RACE_RULE_STATUSES.approved) - (nextRule.status === RACE_RULE_STATUSES.approved);

export const byRuleDate = (rule, nextRule) => {
    if (rule.endDateTime === nextRule.endDateTime) {
        return new Date(rule.startDateTime) - new Date(nextRule.startDateTime);
    }

    return new Date(rule.endDateTime) - new Date(nextRule.endDateTime);
};

export const isCountdownAvailable = (status, displayCountdown, countdownType) =>
    countdownType === COUNT_DOWN_TYPES.static ||
    countdownType === COUNT_DOWN_TYPES.countdown && !isRaceCompleted({ status }) && !isRacePending({ status });
